import SortableTableHead from 'Components/TableBase/SortableTableHead';
import { StyledTable, StyledTableBody } from 'Components/TableBase/Table';
import React, { FC } from 'react';
import { HEADER_COLUMNS, EProductHeaderColumEnum } from '../utils/headerColumns';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';
import { APP_QUERY_PARAMS } from 'utils/queryParam.utils';
import { TSortOrder } from 'types/pagination.types';
import { parseOrderToOrderString } from 'utils/order.utils';
import InfiniteScrollWrapper from 'Components/InfiniteScrollWrapper';
import { IBaseProduct } from 'FeatureModules/ProductPage/types/product.types';
import TableRow, { ITableRowAction } from './TableRow';

interface ISupplyChainTableProps {
  products: IBaseProduct[];
  actions: ITableRowAction[];
  hasNextPage: boolean;
  isArchived?: boolean;
  onPageEndReached: () => void;
  onRowClick?: (product: IBaseProduct) => void;
  'data-testid': string;
}

const SupplyChainTable: FC<ISupplyChainTableProps> = ({
  products,
  'data-testid': dataTestId = '',
  actions,
  hasNextPage,
  isArchived,
  onPageEndReached,
  onRowClick,
}) => {
  const [query, setQuery] = useQueryParams({
    [APP_QUERY_PARAMS.order]: withDefault(StringParam, 'DESC'),
    [APP_QUERY_PARAMS.orderBy]: withDefault(
      StringParam,
      EProductHeaderColumEnum.MODIFIED_TIMESTAMP
    ),
  });
  const order = query[APP_QUERY_PARAMS.order] as TSortOrder | undefined;
  const orderBy = query[APP_QUERY_PARAMS.orderBy];

  const handleRequestSort = (property: string) => {
    const isAsc = orderBy === property && order === 'ASC';
    setQuery({
      [APP_QUERY_PARAMS.order]: isAsc ? 'DESC' : 'ASC',
    });
    setQuery({
      [APP_QUERY_PARAMS.orderBy]: property,
    });
  };

  return (
    <InfiniteScrollWrapper hasMore={hasNextPage} next={onPageEndReached}>
      <StyledTable aria-labelledby="tableTitle" aria-label="enhanced table">
        <SortableTableHead
          order={parseOrderToOrderString(order)}
          orderBy={orderBy}
          headerColumns={HEADER_COLUMNS}
          onSort={handleRequestSort}
        />

        <StyledTableBody data-testid={dataTestId}>
          {products.map(product => (
            <TableRow
              key={product.id}
              product={product}
              actions={actions}
              isArchived={isArchived}
              onRowClick={onRowClick}
            />
          ))}
        </StyledTableBody>
      </StyledTable>
    </InfiniteScrollWrapper>
  );
};

export default SupplyChainTable;
